window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */


try {
    window.moment = require('moment');
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.numeral = require('numeral');
    window.Chart = require('chart.js/auto').default;
    window.bootstrap = require('bootstrap');
    window.Swal = require("sweetalert2");
} catch (e) {}


/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. We use Fetch Metadata headers for CSRF protection
 * instead of tokens, so we need to ensure cookies are sent with requests.
 */

window.axios = require('axios');
axios.defaults.withCredentials = true;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';